module.exports = __webpack_public_path__ + "static/modal2-bcc7b16e0bffbc0fc852d27f82f49e6f.png";